// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1K6EO","header":"PatientQuestionnaire_header__3voGw","info":"PatientQuestionnaire_info__2RJNp"};